"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumerable = enumerable;
function enumerable(value) {
    return (target, prop, descriptor) => {
        if (descriptor) {
            // prototype property
            descriptor.enumerable = value;
        }
        else {
            // instance property
            let propSymbol = Symbol(prop);
            Object.defineProperty(target, prop, {
                configurable: true,
                enumerable: value,
                get() {
                    return this[propSymbol];
                },
                set(value) {
                    this[propSymbol] = value;
                },
            });
        }
    };
}
